// IndividualCourse.js
import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import "../CSS/individualCourse.css";
import { NavLink } from "react-router-dom";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from "react-accessible-accordion";
import 'react-accessible-accordion/dist/fancy-example.css';
import CourseContent, { course_intro } from "./IndividualCourseJSONTemp";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import JoditEditor from "jodit-react";
import { FaPlus } from "react-icons/fa";
import { Popover } from "react-tiny-popover";
import AddResourcePopUp from "./AddResourcePopUp";
import { useSelector } from "react-redux";
import PopupTemp from "./PopUpAdd";



const IndividualCourse = () => {
    const [isLoader, setIsLoader] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const loginInfo = useSelector((state) => state.login); 
    console.log(loginInfo)
//     const initialRichText = `<h1>Hello world</h1>
//   <p>How are you doing?</p>
// `;
    const initialRichText = course_intro;
    const [richText, setRichText] = useState(initialRichText);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)



    useEffect(() => {
        // Simulate loading for 3 seconds
        const loaderTimeout = setTimeout(() => {
            setIsLoader(false);
        }, 3000);

        // Clear the timeout to avoid memory leaks
        return () => clearTimeout(loaderTimeout);
    }, []);

    const course = { id: 1, img: "/python.jpeg", course_name: "SONY AI PYTHON - 2024" };

    const courseHeadingStyle = {
        // Add your styles here
    };

    const accordionItemStyle = {
        backgroundColor: "white",
        marginBottom: "20px",
        border: "none",
    };

    const accordionItemButtonStyle = {
        width: "auto",
        backgroundColor: "#edeff7",
        borderRadius: "20px",
    };

    const onChangeText = e => {
        setRichText(e.html);
    };

    const editor = useRef(null);

    const handleUpdate = (event) => {
        console.log(event)
        const editorContent = event;
        setRichText(editorContent);
    };
    const config = {
        readonly: false,
        height: 400
    };

    const handleAddResource = () => {
        setIsPopoverOpen(true)
    }
    return (
        <>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <>
                    <div className="content-individualCourse">
                        <div className="course-heading-name" style={courseHeadingStyle}>
                            <div>{course.course_name}</div>
                            <div>
                                <NavLink to="/my">Dashboard</NavLink> /
                                <NavLink to="/user/courses"> My Courses</NavLink> / {course.course_name}
                            </div>
                        </div>
                        <div className="course-content">
                            <h2>Course Content</h2>
                            {editMode && (
                                <div className="edit-mode-content">
                                    {/* Add your edit mode content here */}
                                </div>
                            )}
                            {(loginInfo.user_role==="T" || loginInfo.user_role==="A") && <button className="edit-button" onClick={() => setEditMode(!editMode)}>
                                {editMode ? "Turn Editing Off" : "Turn Editing On"}
                            </button>}
                            <Accordion allowZeroExpanded={true} style={{ border: "none" }}>
                                {CourseContent.map((obj, index) => (
                                    <AccordionItem key={index} style={accordionItemStyle}>
                                        <AccordionItemHeading style={{ backgroundColor: "#edeff7", borderRadius: "15px" }}>
                                            <AccordionItemButton style={accordionItemButtonStyle}>
                                                {obj.name}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        {
                                            obj.name != "COURSE INTRODUCTION" ?
                                                <AccordionItemPanel>
                                                    {obj.content}
                                                    {/* <div dangerouslySetInnerHTML={{ __html: richText }} /> */}
                                                    <div className="course-horizontal-line"></div>

                                                    <div>
                                                        {/* <Popover
                                                            isOpen={isPopoverOpen}
                                                            positions={["bottom", "top", "right", "left"]}
                                                            align="start"
                                                            padding={8}
                                                            // onClickOutside={() => setIsPopoverOpen(false)}
                                                            className="popover"
                                                            content={({ position, childRect, popoverRect }) => (
                                                                <AddResourcePopUp />
                                                            )}
                                                        >
                                                            <button
                                                                className="row navigation-button"
                                                                style={{ marginLeft: "auto" }}
                                                                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                                                            >
                                                                <FaPlus /> &nbsp;
                                                                Add an activity or resource
                                                            </button>

                                                        </Popover> */}
                                                        <PopupTemp/>
                                                    </div>

                                                </AccordionItemPanel>


                                                :


                                                editMode ? <AccordionItemPanel>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={richText}
                                                        config={config}
                                                        onBlur={handleUpdate}
                                                        onChange={(newContent) => { }}
                                                    />
                                                </AccordionItemPanel>
                                                    :
                                                    <AccordionItemPanel>
                                                        {/* {obj.content} */}
                                                        <div dangerouslySetInnerHTML={{ __html: richText }} />
                                                        <div className="course-horizontal-line"></div>
                                                    </AccordionItemPanel>


                                        }
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        </div>
                    </div>
        

                </>
            )}
            <Footer />
        </>
    );
};

export default IndividualCourse;
